exports = module.exports = require("../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "body {\r\n    font-family: sans-serif;\r\n    background: rgba(245, 245, 241, 0.349);\r\n}\r\n\r\n#appContainer{\r\n    margin: auto;\r\n    width: 30%;\r\n}", ""]);
